import React, { useEffect, useState } from 'react';
import { AppPortal } from 'svix-react';
import { useSearchParams } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import { useFetch } from './api';

// svix reads ?next= as a query param but keeps the session key in the fragment,
// so let the URL parser put it in the right half
function withMessageFilter(portalUrl, tag) {
  if (!tag) {
    return portalUrl;
  }
  const url = new URL(portalUrl);
  url.searchParams.set('next', `/messages?tags=${tag}`);
  return url.toString();
}

function Webhooks() {
  const trackstar = useFetch();
  const [searchParams] = useSearchParams();
  const tag = searchParams.get('tags');
  const [url, setUrl] = useState('');
  useEffect(() => {
    trackstar('svix/app-portal').then((data) => {
      setUrl(withMessageFilter(data.url, tag));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);

  const spinner = (
    <div className="flex items-center justify-center h-full">
      <ClipLoader size={32} color="#D4532A" />
    </div>
  );

  return (
    <div className="page-container">
      <div className="flex items-baseline gap-3">
        <h1 className="page-title">Webhooks</h1>
        <span className="page-subtitle">
          {tag ? `Delivery logs for ${tag}` : 'Configure event notifications'}
        </span>
      </div>

      <div className="flex-1 min-h-0 card overflow-hidden">
        {url ? <AppPortal key={url} url={url} loadingIndicator={spinner} style={{ height: '100%' }} /> : spinner}
      </div>
    </div>
  );
}

export default Webhooks;
